import { promiseWrapper } from 'utils/promise'
import {
  ExchangeTransferCalculate,
  CurrencyExchangeDetails,
  ChosenItemTransfer,
} from 'models/exchange-transfer-calculate'
import { Domains } from 'services/domains-api'

declare const USER_BASE_URL_WT: string

export const exchangeTransfer = async (
  exchangeDetails: CurrencyExchangeDetails,
  chosenTransfer: ChosenItemTransfer = {},
  originCountry?: string,
  destinationCountry?: string,
  apiDomain?: Domains['base_user'],
  abortController?: AbortController,
  headers: Record<string, string> | null = null,
): Promise<ExchangeTransferCalculate> => {
  const { direction, baseAmount, counterAmount, baseCurrency, counterCurrency } = exchangeDetails
  const { chosenItemTransferFee = '', chosenItemTransferType = '' } = chosenTransfer

  const apiDomainUrl = apiDomain || USER_BASE_URL_WT
  const boughtAmount = direction === 'forward' ? baseAmount : ''
  const soldAmount = direction === 'back' ? counterAmount : ''
  const soldCurrency = direction === 'forward' ? counterCurrency : baseCurrency
  const boughtCurrency = direction === 'forward' ? baseCurrency : counterCurrency
  const fromCountry = originCountry || 'PL'
  const toCountry = destinationCountry || 'PL'

  const queryParams = new URLSearchParams(
    Object.fromEntries(
      Object.entries({
        unit: '3', // '3' is the unit for the WT service
        bought_amount: boughtAmount,
        sold_amount: soldAmount,
        sold_currency: soldCurrency,
        bought_currency: boughtCurrency,
        from_country: fromCountry,
        to_country: toCountry,
        transfer_type_fee: chosenItemTransferFee,
        transfer_type: chosenItemTransferType,
      }).filter(([, value]) => value),
    ),
  )

  const url = `${apiDomainUrl}/api/public/exchangeTransferCalculate?${queryParams.toString()}`

  return await promiseWrapper<ExchangeTransferCalculate, null>(url, 'GET', null, headers, abortController?.signal)
}
